import { ReactNode } from 'react';
import tw from 'twin.macro';

const RadioButtonOuterWrapper = tw.button`flex items-center justify-center cursor-pointer`;
const RadioButtonInnerWrapper = tw.div`w-[13px] h-[13px] min-w-[13px] min-h-[13px] border border-solid border-sec-2 rounded-full flex items-center justify-center p-1 bg-white`;
const StyledRadioButton = tw.div`w-[6px] h-[6px] min-w-[6px] min-h-[6px] rounded-full flex items-center justify-center p-1`;

export const RadioButton = ({
  onChange,
  selected,
  title,
  children,
  className,
  ...rest
}: {
  onChange: () => void;
  selected: boolean;
  children?: ReactNode;
  title?: string;
  className?: string;
}) => {
  return (
    <RadioButtonOuterWrapper onClick={onChange} title={title} className={className} {...rest}>
      <RadioButtonInnerWrapper>
        <StyledRadioButton css={[selected && tw`bg-accent-muted`]} />
      </RadioButtonInnerWrapper>
      {children}
    </RadioButtonOuterWrapper>
  );
};
